var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.276 17.075L13.617 4.373a1.93 1.93 0 00-3.234 0L2.726 17.072a1.5 1.5 0 00-.029 1.492 1.87 1.87 0 001.627.936h15.362a1.87 1.87 0 001.625-.91 1.5 1.5 0 00-.031-1.509l-.004-.006zm1.334 2.265A3.37 3.37 0 0119.67 21H4.33a3.37 3.37 0 01-2.94-1.7 3 3 0 01.05-3L9.11 3.58a3.43 3.43 0 015.78 0l7.67 12.72a3 3 0 01.05 3.04z",
    fill: "#D84C45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17a1 1 0 100-2 1 1 0 000 2zM12 8a1 1 0 00-1 1v4a1 1 0 002 0V9a1 1 0 00-1-1z",
    fill: "#D84C45"
  })));
};

export default SvgError;